import { KOCH_SWIPER_A11Y } from '../../scripts/swiper-defaults';

export function initReviewsSliders() {
    const sliders = document.querySelectorAll('[data-koch-reviews-slider]');
    if (!sliders.length || typeof Swiper === 'undefined') {
        return;
    }

    sliders.forEach((slider) => {
        if (slider.swiper) {
            return;
        }

        const root = slider.closest('.koch-reviews__slider') || slider;
        const prev = root.querySelector('.koch-reviews__arrow--prev');
        const next = root.querySelector('.koch-reviews__arrow--next');
        const slideCount = slider.querySelectorAll('.swiper-slide').length;

        new Swiper(slider, {
            a11y: KOCH_SWIPER_A11Y,
            slidesPerView: 1,
            spaceBetween: 16,
            loop: slideCount > 3,
            watchOverflow: true,
            autoplay: slideCount > 1
                ? {
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }
                : false,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
        });
    });
}
